
<div class="container animated fadeIn">
  <div class="title">
    <h1>Heroes</h1>
    <small>Super heroes from Marvel and DC Comics.</small>
  </div>

  <div class="heroes">

    <!-- -->
    <app-hero-card [hero]="superHero" *ngFor="let superHero of heroes"></app-hero-card>

  </div>


</div>